import React, {useEffect, useState, Suspense} from "react";
import { NavLink } from "react-router-dom";
import navStyle from "../styles/Navigation.module.scss";
import {useTranslation} from "react-i18next";

const mobileMediaQuery = '(max-width: 750px)'

function HeaderComponent() {
  const [t, i18n] = useTranslation('translation');

  const [language, setLanguage] = useState("en")
  const transClick = () =>{
    language==="en"? setLanguage("de") : setLanguage("en")
    i18n.changeLanguage(language)
  }

  const [isActive, setIsActive] = useState(window >= mobileMediaQuery);
  const menuClick = () => {
    // toggle
    setIsActive(current => !current);
  };

  const [isMobile, setIsMobile] = useState(window.matchMedia(mobileMediaQuery).matches);


  useEffect(() => {
    
    const query = window.matchMedia(mobileMediaQuery);

    function handleQueryChange(queryEvent) {
      /* The matches property will be true if the window width is above the mobile size. */
      setIsMobile(queryEvent >= mobileMediaQuery);
      setIsActive(queryEvent >= mobileMediaQuery);
    }

    query.addEventListener('change', handleQueryChange);

    return () => {
      query.removeEventListener('change', handleQueryChange);
    };
  }, []);

    return <header>
<div>
	<nav>
	<button className={navStyle.lngSwitch} onClick={transClick}>{t('trans.prompt')}</button>
		<div id={navStyle.menu}>
			<button id={navStyle.menulink} onClick={menuClick}>Menu</button>
			{isActive && (
				<ul id={navStyle.navlinks}>
				<li><NavLink to="/" >Home</NavLink></li>
				<li><NavLink to="ueber_uns" >{t('nav.about')}</NavLink></li>
				<li><NavLink to="beispiele" >{t('nav.example')}</NavLink></li>
				<li><NavLink to="rezensionen" >{t('nav.review')}</NavLink></li>
				<li><NavLink to="kontakt" >{t('nav.contact')}</NavLink></li>
			</ul>
			)}
			
		</div>
	</nav>
	<img src="./images/logo.svg" alt="logo" />
	<h1>Nikolaus Veeser</h1>
	<h6>{t('nav.subtitle')}</h6>
</div>
</header>
}

function Navigation() {
  return (
	<Suspense fallback="loading">
            <div className="App">
                <HeaderComponent/>
            </div>
        </Suspense>
  );
}

export default Navigation;